// Basic config for dapp
const config  = {
    symbol: "ERMY",
    page_title: "Elons Army",
    favicon: "https://metagochi.com/wp-content/uploads/2021/12/cropped-favicon.png",
    logo: "/img/logo.png"
};
export default config;